import { useRoutes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Layout from './components/Layout';
import AuthLayout from './components/AuthLayout';
import Home from './pages/Home';

const CopyrightHolders = lazy(() => import('./pages/CopyrightHolders'));
const Advertise = lazy(() => import('./pages/Advertise'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const About = lazy(() => import('./pages/About'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Catalog = lazy(() => import('./pages/Catalog'));
const Profile = lazy(() => import('./pages/Profile'));
const Top100 = lazy(() => import('./pages/Top100'));
const New = lazy(() => import('./pages/New'));
const Ongoing = lazy(() => import('./pages/Ongoing'));
const Bookmarks = lazy(() => import('./pages/Bookmarks'));
const History = lazy(() => import('./pages/History'));
const Settings = lazy(() => import('./pages/Settings'));
const Watch = lazy(() => import('./pages/Watch'));
const Lakorns = lazy(() => import('./pages/Lakorns'));
const TopUsers = lazy(() => import('./pages/TopUsers'));
const UserProfile = lazy(() => import('./pages/UserProfile'));
const Notifications = lazy(() => import('./pages/Notifications'));

// Genres/Countries — тривиальные страницы-заглушки без отдельного файла
// (раньше жили инлайн в pages/Pages.js). React.lazy требует реальный
// import() модуля, поэтому оставляем их обычными (не lazy) компонентами.
const PageTemplate = ({ title, description }) => (
  <div style={{
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '60px 40px',
    textAlign: 'center'
  }}>
    <h1 style={{
      fontFamily: 'Playfair Display, serif',
      fontSize: '48px',
      marginBottom: '20px',
      background: 'var(--accent-gradient)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    }}>
      {title}
    </h1>
    <p style={{ color: 'var(--text-secondary)', fontSize: '18px' }}>
      {description}
    </p>
  </div>
);
const Genres = () => <PageTemplate title="Жанры" description="Все жанры дорам" />;
const Countries = () => <PageTemplate title="Страны" description="Дорамы по странам" />;

const RouteFallback = () => (
  <div style={{ minHeight: '60vh' }} aria-hidden="true" />
);

const withSuspense = (element) => <Suspense fallback={<RouteFallback />}>{element}</Suspense>;

const AppRoutes = () => {
  const routes = useRoutes([
    {
      path: '/auth',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: withSuspense(<Login />) },
        { path: 'register', element: withSuspense(<Register />) },
      ],
    },
    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: 'catalog', element: withSuspense(<Catalog />) },
        { path: 'profile', element: withSuspense(<Profile />) },
        { path: 'my', element: withSuspense(<Profile />) },
        { path: 'top-100', element: withSuspense(<Top100 />) },
        { path: 'new', element: withSuspense(<New />) },
        { path: 'ongoing', element: withSuspense(<Ongoing />) },
        { path: 'genres', element: <Genres /> },
        { path: 'countries', element: <Countries /> },
        { path: 'bookmarks', element: withSuspense(<Bookmarks />) },
        { path: 'history', element: withSuspense(<History />) },
        { path: 'notifications', element: withSuspense(<Notifications />) },
        { path: 'settings', element: withSuspense(<Settings />) },
        { path: 'copyright', element: withSuspense(<CopyrightHolders />) },
        { path: 'advertise', element: withSuspense(<Advertise />) },
        { path: 'privacy', element: withSuspense(<PrivacyPolicy />) },
        { path: 'about', element: withSuspense(<About />) },
        { path: 'lakorns', element: withSuspense(<Lakorns />) },
        { path: 'top-users', element: withSuspense(<TopUsers />) },
        { path: 'dorama/:slugParam', element: withSuspense(<Watch />) },
        { path: 'user/:userId', element: withSuspense(<UserProfile />) }
      ],
    },
  ]);

  return routes;
};

export default AppRoutes;
